import { Service } from "planning-portal-library/src/lib/core/domain";


export class GetServices {
  static readonly type = "[Services] Get Services";

  constructor(public payload: Service[] | undefined) {
  }
}

export class SelectedService {
  static readonly type = "[Services] Selected Services";

  constructor(public payload: Service | undefined) {
  }
}

export class IsAttachService {
  static readonly type = "[Services] Is Attach Service";

  constructor(public payload: boolean | undefined) {
  }
}

export class IsSidebarToggled {
  static readonly type = '[Services] Is Sidebar Collapsed';

  constructor(public payload: boolean | undefined) {}
}
